import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import PhotosPricingTableDesktop from "./PhotosPricingTableDesktop";
import PhotosPricingTableMobile from "./PhotosPricingTableMobile";

import { SHOW_DESKTOP_TABLE_MIN_SCREEN_WIDTH } from "./data";

const PhotosPricingTable = () => {
    const showDesktopTable = useMediaQuery(
        `(min-width: ${SHOW_DESKTOP_TABLE_MIN_SCREEN_WIDTH})`
    );
    const table = showDesktopTable ? (
        <PhotosPricingTableDesktop />
    ) : (
        <PhotosPricingTableMobile />
    );

    return table;
};

export default PhotosPricingTable;
